import type { Altersvorsorge } from '@/bedarf/components/altersvorsorge/altersvorsorge/types';
import { usePost } from "@/api/lib/integration";

export const storeAltersvorsorge = usePost<Altersvorsorge, void>('/api/altersvorsorge');
